import { useState } from 'react';
import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalBody,
   ModalCloseButton,
   Avatar,
} from '@chakra-ui/react';
import { useWikis } from './useWikis';
import {
   Catalog,
   CatalogItem,
   CatalogItemContent,
   CatalogItemHeader,
   SearchForm,
} from '~/ui-components';
import { useLocalization } from '~/framework';
import { useDebounced } from '@dozuki/web-js/components';
import { useStageEditor } from '../StageEditor';
import type { WikiPage } from '~/pages/api/wikis';

export function WikiSearchModal() {
   const { _js } = useLocalization();

   const stageEditor = useStageEditor();

   const [searchTerm, setSearchTerm] = useState('');
   const debouncedSearchTerm = useDebounced(searchTerm, 500);
   const { data: wikis } = useWikis(debouncedSearchTerm);

   function handleClose() {
      stageEditor.closeOpenModal();
      setSearchTerm('');
   }

   function handleWikiSelected(wiki: WikiPage) {
      stageEditor.addStage({
         doctype: 'wiki',
         docid: wiki.wikiid,
         frequency_unit: null,
         use_datacapture: null,
         frequency_quantity: null,
         strictness: null,
         docSummaryInfo: {
            title: wiki.display_title,
            standardImage: wiki.image?.thumbnail,
            public: true,
         },
      });
      setSearchTerm('');
   }

   return (
      <Modal isOpen={stageEditor.isWikiSearchModalOpen} onClose={handleClose} size="xl">
         <ModalOverlay />
         <ModalContent>
            <ModalHeader>{_js('Choose a Wiki')}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
               <SearchForm
                  name="wiki-search"
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                  placeholder={_js('Search for a Wiki')}
               />
               <Catalog>
                  {wikis?.map(wiki => (
                     <CatalogItem key={wiki.wikiid} onClick={() => handleWikiSelected(wiki)}>
                        <Avatar src={wiki.image?.thumbnail} />
                        <CatalogItemContent>
                           <CatalogItemHeader>{wiki.display_title}</CatalogItemHeader>
                        </CatalogItemContent>
                     </CatalogItem>
                  ))}
               </Catalog>
            </ModalBody>
         </ModalContent>
      </Modal>
   );
}
